import React from 'react'
import '../../styles/projectDet.css';  
import BackButton from '../../components/UI/Scrolling/Back'
import Slider from '../../components/UI/Sliders/Photos_slider_digitain'

const Digitain = () => {
  return (
    <section >
    <div className='container'>
    <BackButton />     

        <h2 className='subheaderTrain'>Short description of the training:</h2> 
                <ul className='description'>
                    <li className='lister'>Introduction to R programming and Statistical learning.</li>
                    <li className='lister'>Design of Experiments.</li>
                    <li className='lister'>Analysis of the experiment results: Hypothesis testing.</li>
                </ul> 
                <br></br> <br></br>
                
            
            <div className='about__img_1'>
                {/* <img src={aboutImg} alt="" /> */}
        </div>
        < Slider/>
    </div>
</section>

    
  )
}
export default Digitain;
